<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5865 5398"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0" d="M5458 0l-5039 0c-489,0 -407,332 -407,332l5852 0c0,0 35,-332 -406,-332z"/>
  <polygon class="fil0" points="0,1573 5858,1573 5858,1241 0,1241 "/>
  <polygon class="fil0" points="0,2882 5858,2882 5858,2550 0,2550 "/>
  <polygon class="fil0" points="0,4123 5858,4123 5858,3790 0,3790 "/>
  <polygon class="fil0" points="0,5398 5858,5398 5858,5065 0,5065 "/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'JalousieOpen',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
